import store from '@/store';
import { ENV } from '../../config/app-env';

// Google requires a global function to handle some of its errors, it is defined here
// because this requires custom logic depending on the page structure
if (typeof window !== 'undefined') {
  // @ts-ignore
  window.gm_authFailure = () => {
    store.dispatch('globalAutocomplete', { loadError: true });
  };
}

if (
  ENV.GOOGLE_PLACES_API_KEY &&
  typeof window !== 'undefined' &&
  typeof document !== 'undefined'
) {
  (function () {
    const scriptTags = Array.from(document.getElementsByTagName('script'));
    const elementAlreadyExists = scriptTags.some(
      (tag) =>
        tag.src && tag.src.startsWith('https://maps.googleapis.com/maps'),
    );
    if (!elementAlreadyExists) {
      const firstScriptTag = scriptTags[0];
      const gs = document.createElement('script');
      gs.src = `https://maps.googleapis.com/maps/api/js?key=${ENV.GOOGLE_PLACES_API_KEY}&libraries=places&language=${store.getters.selectedLanguage}&loading=async`;
      gs.async = true;
      gs.defer = true;
      gs.id = 'google-places-script';
      if (firstScriptTag?.parentNode) {
        firstScriptTag.parentNode.insertBefore(gs, firstScriptTag);
      }
    }
  })();
}
